import { render, staticRenderFns } from "./HealthChecklist.vue?vue&type=template&id=9207681a&scoped=true&"
import script from "./HealthChecklist.vue?vue&type=script&lang=js&"
export * from "./HealthChecklist.vue?vue&type=script&lang=js&"
import style0 from "./HealthChecklist.vue?vue&type=style&index=0&id=9207681a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9207681a",
  null
  
)

export default component.exports